export enum Variant {
  VARIANT_BRONZE = 'VARIANT_BRONZE',
  VARIANT_SILVER = 'VARIANT_SILVER',
  VARIANT_GOLD = 'VARIANT_GOLD',
}

export const variants = [
  Variant.VARIANT_BRONZE,
  Variant.VARIANT_SILVER,
  Variant.VARIANT_GOLD,
];

export interface TermsProps {
  variant?: Variant;
}

export class Terms {
  variant?: Variant;

  constructor(props: TermsProps) {
    this.variant = props.variant;
  }

  resetOnCountryChange() {
    this.variant = undefined;
  }

  upsell(variant: Variant) {
    this.variant = variant;
  }
}
